export default {
    user(state) {
        return state.user
    },
    company(state) {
        return state.company
    }
}
